import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-data-protection',
  templateUrl: './user-data-protection.component.html',
  styleUrls: ['./user-data-protection.component.less']
})
export class UserDataProtectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
